import React from 'react'

const WarningOrangeSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 65.275 57.675'
    >
      <g id='warning-svgrepo-com' transform='translate(0 -28.438)'>
        <path
          id='Path_1543'
          data-name='Path 1543'
          d='M64.7,79.7,36.339,30.573a4.277,4.277,0,0,0-7.4,0L.578,79.7a4.279,4.279,0,0,0,3.7,6.415H61A4.279,4.279,0,0,0,64.7,79.7Zm-32.02-34a3.241,3.241,0,0,1,3.234,3.328l-.535,18.656a2.714,2.714,0,0,1-5.426,0L29.43,49.028A3.252,3.252,0,0,1,32.677,45.7Zm-.04,33.743A3.368,3.368,0,1,1,36,76.076,3.371,3.371,0,0,1,32.637,79.444Z'
          transform='translate(0 0)'
          fill='#E66725'
        />
      </g>
    </svg>
  )
}

export default WarningOrangeSvg
